import { setAuthToken } from '../../../utils/session/sessionStorage'

const AuthWithToken = ({ children, token }) => {
  setAuthToken(token)

  return 'TODO: AuthWithToken incomplete'
  // TODO: Check if needs reloading or anything else
  // return <LoggedUserLoader>{children}</LoggedUserLoader>
}

export default AuthWithToken
